/*
 * TODO:
 * These are not routes but rather constants
 * Rename file & varialbe something like
 * routePaths.consts/routes.consts
 */

const ROUTES = {
  home: '/',
  login: '/login',
  projects: {
    overview: {
      byProjectId: {
        path: '/project-overview/:projectId',
        url: (param) => `/project-overview/${param}`,
      },
      general: {
        path: '/overview',
        url: '/overview',
      },
    },
    timeline: {
      general: {
        path: '/timeline',
        url: '/timeline',
      },
    },
    writerMatch: {
      path: '/projectsW/:projectId/writer-match',
      url: (param) => `/projectsW/${param}/writer-match`,
    },
    list: {
      general: {
        path: '/all-projects',
        url: '/all-projects',
      },
      writer: {
        path: '/my-projects',
        url: '/my-projects',
      },
    },
    create: {
      path: '/projects/create',
      url: '/projects/create',
    },
    edit: {
      path: '/projects/:projectId/edit',
      url: (param) => `/projects/${param}/edit`,
    },
    draft: {
      byProjectId: {
        path: '/project/:projectId/chapters/:index',
        url: (projectId, chapterIndex = 1) => `/project/${projectId}/chapters/${chapterIndex}`,
      },
      byChapterIndex: {
        path: '/draft/:index',
        url: (param) => `/draft/${param}`,
      },
    },
    versions: {
      byProjectId: {
        path: '/project/:projectId/chapters/:chapterNumber/versions',
        url: (projectId, chapterNumber) => `/project/${projectId}/chapters/${chapterNumber}/versions`,
      },
      general: {
        path: '/chapter/:chapterNumber/versions',
        url: (param) => `/chapter/${param}/versions`,
      },
    },
    questionnaire: {
      create: {
        path: '/project/:projectId/questionnaire-creator',
        url: (param) => `/project/${param}/questionnaire-creator`,
      },
      general: {
        path: '/questionnaire',
        url: '/questionnaire',
      },
      answers: {
        path: '/project/:projectId/questionnaire-answers',
        url: (param) => `/project/${param}/questionnaire-answers`,
      },
    },
    bookSpecification: {
      byProjectId: {
        path: '/project/:projectId/book-specification',
        url: (param) => `/project/${param}/book-specification`,
      },
    },
    outline: {
      byProjectId: {
        path: '/project/:projectId/outline',
        url: (param) => `/project/${param}/outline`,
      },
      general: {
        path: '/outline',
        url: '/outline',
      },
    },
    bookSample: {
      byProjectId: {
        path: '/project/:projectId/book-sample',
        url: (param) => `/project/${param}/book-sample`,
      },
      general: {
        path: '/book-sample',
        url: '/book-sample',
      },
    },
    photos: {
      byProjectId: {
        path: '/project/:projectId/photos',
        url: (param) => `/project/${param}/photos`,
      },
      general: {
        path: '/photos',
        url: '/photos',
      },
    },
    coverCreator: {
      byProjectId: {
        path: '/project/:projectId/cover-creator',
        url: (param) => `/project/${param}/cover-creator`,
      },
      general: {
        path: '/cover-creator',
        url: '/cover-creator',
      },
    },
    proof: {
      byProjectId: {
        path: '/project/:projectId/final-proof',
        url: (param) => `/project/${param}/final-proof`,
      },
      general: {
        path: '/final-proof',
        url: '/final-proof',
      },
    },
    upgrades: {
      byProjectId: {
        path: '/project/:projectId/upgrades',
        url: (param) => `/project/${param}/upgrades`,
      },
      general: {
        path: '/upgrades',
        url: '/upgrades',
      },
    },
    interviews: {
      general: {
        path: '/interviews',
        url: '/interviews',
      },
      byProjectId: {
        path: '/project/:projectId/interviews',
        url: (param) => `/project/${param}/interviews`,
      },
    },
    styleSamples: {
      general: {
        path: '/style-samples',
        url: '/style-samples',
      },
      byProjectId: {
        path: '/project/:projectId/style-samples',
        url: (projectId) => `/project/${projectId}/style-samples`,
      },
    },
    projectsFeedback: {
      general: {
        path: '/projects-feedback',
        url: '/projects-feedback',
      },
    },
    onboardingFeedback: {
      general: {
        path: '/onboarding-feedback',
        url: '/onboarding-feedback',
      },
    },
    proofFeedback: {
      general: {
        path: '/proof-feedback',
        url: '/proof-feedback',
      },
    },
    writerFeedback: {
      general: {
        path: '/writer-feedback',
        url: '/writer-feedback',
      },
    },
  },
  accounts: {
    allAccounts: {
      path: '/all-accounts',
      url: '/all-accounts',
    },
    editAccount: {
      path: '/account/edit/:userId',
      url: (userId) => `/account/edit/${userId}`,
    },
    accountDetails: {
      url: (userId) => `/account/${userId}`,
      path: '/account/:userId',
    },
    addAccount: {
      path: '/add-account',
      url: '/add-account',
    },
  },
  noProjectForCustomer: '/no-project-for-customer',
  upgradesTable: '/upgrades-table',
  promptLibrary: '/prompt-library',
  allUpgrades: '/all-upgrades',
};

export default ROUTES;
